import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-wrapper" }
const _hoisted_2 = { class: "section-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_4 = { class: "emq-table-footer" }

import { getProfitsharingStrategyList } from '@/api/operation'
import { dateFormat } from '@/common/tools'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import Payees from '@/components/Payees.vue'
import StrategyAuthDrawer from '@/views/ProfitSharing/components/StrategyAuthDrawer.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { Refresh, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import StrategyUpsert from '@/views/ProfitSharing/components/StrategyUpsert.vue'
import { Ref, withDefaults, onMounted } from 'vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'

import { defineComponent, ref } from 'vue'
const __default__ = defineComponent({
  name: 'StrategysTable',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    name: { default: '' },
    strategyId: { default: '0' },
    operatorId: { default: '0' },
    stationId: { default: '0' }
  },
  setup(__props: any, { expose }) {

const props = __props as { name: string, strategyId: string, operatorId: string, stationId: string }

const { t } = useI18nTl('Evses')


const showStrategyDialog = ref(false)
const showDialog = ref(false)
const showIsEdit = ref(false)
const showInfo: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const { getProfitSharingSourceDesc } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')

const addInfo = () => {
  showDialog.value = true
  showInfo.value = undefined
  showIsEdit.value = false
}

const editStrategyAuth = (info: any) => {
  showStrategyDialog.value = true
  showInfo.value = info
}

const editInfo = (info: any) => {
  showDialog.value = true
  showInfo.value = info
  showIsEdit.value = true
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...props,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }
  try {
    const { list = [], pageReply = {} } = await getProfitsharingStrategyList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...props })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}

onMounted(() => loadTableData())

expose({
  loadTableData,
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (addInfo()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
        ]),
        _: 1
      }, 8, ["icon"])), [
        [_directive_role, 'strategyAdd']
      ]),
      _createVNode(_component_el_button, {
        type: "primary",
        plain: "",
        icon: _unref(Refresh),
        onClick: loadTableData
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
        ]),
        _: 1
      }, 8, ["icon"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      ref_key: "TableCom",
      ref: TableCom,
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          "min-width": "80",
          label: _ctx.$t('Base.name'),
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              content: row.id,
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(PreWithEllipsis, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["content"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "operatorName",
          "min-width": "100",
          label: _ctx.$t('Operation.operator')
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(LinkOperator, {
              id: row.operatorId,
              name: row.operatorName
            }, null, 8, ["id", "name"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "ower.payeeName",
          "min-width": "80",
          label: _ctx.$t('Operation.strategyOwer')
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "source",
          "min-width": "80",
          label: _ctx.$t('Operation.profitSharingSource')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(getProfitSharingSourceDesc)(row.source)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "payees",
          "min-width": "80",
          label: _ctx.$t('Operation.profitSharingConfig')
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(Payees, {
              ados: row.payees
            }, null, 8, ["ados"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "createdAt",
          "min-width": "100",
          label: _ctx.$t('Base.createdAt')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('Base.operation'),
          "class-name": "table-operation"
        }, {
          default: _withCtx(({ row }) => [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              plain: "",
              onClick: ($event: any) => (editInfo(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_role, 'strategyUpsert']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              plain: "",
              onClick: ($event: any) => (editStrategyAuth(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.auth')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_role, 'strategyAuthList']
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [
        _directive_loading,
        lockTable.value,
        void 0,
        { lock: true }
      ]
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(CommonPagination, {
        metaData: _unref(pageMeta),
        "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
        onLoadPage: loadTableData
      }, null, 8, ["metaData"])
    ]),
    _createVNode(StrategyUpsert, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
      info: showInfo.value,
      isEdit: showIsEdit.value,
      onSubmitted: loadTableData,
      operatorId: props.operatorId
    }, null, 8, ["modelValue", "info", "isEdit", "operatorId"]),
    _createVNode(StrategyAuthDrawer, {
      modelValue: showStrategyDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showStrategyDialog).value = $event)),
      info: showInfo.value
    }, null, 8, ["modelValue", "info"])
  ]))
}
}

})